import axios from 'axios'
window.axios = axios
Vue.prototype.$axios = axios

import { getPreviewUrl, getUrlParam } from './util';
import { langConfig } from './settings'

// 请求拦截处理器
const requestHanlder = config => {
  const locale = langConfig[window.i18n.locale] || 'en-US';
  config.headers['X-LANG'] = locale
  // 如果是处于预览模式
  if (window.onPreviewLinkObserver) {
    const previewCode = getUrlParam('preview')
    const { url } = config
    let newUrl = url
    if (previewCode) {
      newUrl = getPreviewUrl(url, previewCode)
    }

    config.url = newUrl
  }
  return config
}

// 请求拦截
axios.interceptors.request.use(requestHanlder)

// 响应拦截处理器
const responseHandler = res => {
  if (res && res.data && res.data.notices && res.data.notices.length) {
    res.data.notices.forEach((item, index) => {
      ELEMENT.Message({
        showClose: true,
        message: item,
        type: 'error',
        duration: 0,
        offset: 60 * (index + 1),
      })
    })
  }
  return res
}
// 响应异常拦截处理器
const responseErrHandler = error => {
  if(error?.response?.status ===504){
     error.response.data ={message:'Connection timed out, please try again'}
  }
  return Promise.reject(error);
}

// 响应拦截
axios.interceptors.response.use(responseHandler, responseErrHandler)

// ！！！先放在这里，因为这个是所有主题都会引用的文件！！！
// 解决移动端a标签因为hover点击两次的问题
document.body.addEventListener('touchstart', function () { });
